/**
 * @author 3173
 * @description 岗位能力管理
 * @Date  2020/7/17
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";
import { handleExportHeader } from '@/utils/handleTabelHeaderUtils';

import { component_tool, framework_tool } from '../../../../tool';
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport } = component_tool;


class AbilityCheckCategoryList extends WizContainer {
  componentName = 'abilityCheckCategoryList';
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let headList = o.data['headList']
      let dataList = o.data['dataList']
      WizBrowserExport({
        title: '能力考核项目信息',
        sheetName: '能力考核项目信息',
        columns: handleExportHeader(headList).filter((_, index) => index),
        rows: dataList,
        filename: '能力考核项目信息.xlsx',
      })

      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        enable: this._handleCMD,
        export: this._handleFile
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(AbilityCheckCategoryList);
